module.exports = __webpack_public_path__ + "img/img-intro1@2x.dad4953f.jpg";